<template>
  <div class="privacy-page">
    <div class="background-glow background-glow--one"></div>
    <div class="background-glow background-glow--two"></div>

    <header class="topbar">
      <a href="/" class="brand" aria-label="Voltar para a página inicial do ControlEase">
        <div class="brand-icon" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="brand-text">
          <strong>ControlEase</strong>
          <small>Gestão financeira</small>
        </div>
      </a>

      <a href="/" class="home-button">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15 18l-6-6 6-6" />
        </svg>
        <span>Voltar para a home</span>
      </a>
    </header>

    <main class="privacy-shell">
      <section class="privacy-hero">
        <span class="eyebrow">Transparência & Uso</span>
        <h1>Termos de Uso</h1>
        <p class="hero-description">
          Regras e condições para utilização dos serviços, recursos e funcionalidades
          disponibilizados pelo ControlEase.
        </p>
        <div class="updated">
          <span class="updated-dot"></span>
          Última atualização: 26 de agosto de 2026
        </div>
      </section>

      <article class="privacy-container">
        <p>
          Estes Termos de Uso estabelecem as condições aplicáveis ao acesso e à utilização
          do <strong>ControlEase</strong> ("Plataforma"). Ao criar uma conta, acessar ou
          utilizar nossos serviços, você declara que leu, compreendeu e concorda com estes
          Termos e com nossa Política de Privacidade.
        </p>

        <h2>1. Sobre o ControlEase</h2>
        <p>
          O ControlEase é uma plataforma de gestão financeira pessoal criada para auxiliar
          usuários na organização de informações como gastos, receitas, metas, saldos,
          investimentos, assinaturas, financiamentos, projetos e demais registros financeiros.
        </p>
        <p>
          A Plataforma também pode disponibilizar recursos de automação, notificações,
          integração com serviços de terceiros e um assistente virtual com inteligência
          artificial, inclusive por meio do WhatsApp.
        </p>

        <h2>2. Aceitação dos Termos</h2>
        <p>
          Ao utilizar o ControlEase, você concorda em cumprir estes Termos. Caso não concorde
          com alguma condição aqui descrita, você não deverá utilizar a Plataforma.
        </p>
        <p>
          O uso de determinados recursos poderá estar sujeito a condições adicionais,
          apresentadas no momento da contratação, ativação ou utilização da funcionalidade.
        </p>

        <h2>3. Cadastro e conta do usuário</h2>
        <ul>
          <li>Você deve fornecer informações verdadeiras, completas e atualizadas no cadastro;</li>
          <li>Você é responsável por manter a confidencialidade de sua senha e credenciais;</li>
          <li>Você é responsável pelas atividades realizadas através de sua conta;</li>
          <li>
            Caso identifique acesso não autorizado ou suspeita de comprometimento da conta,
            deverá entrar em contato conosco assim que possível;
          </li>
          <li>
            Não é permitido criar contas utilizando dados de terceiros sem autorização.
          </li>
        </ul>

        <h2>4. Informações financeiras</h2>
        <p>
          O ControlEase funciona como uma ferramenta de organização e acompanhamento financeiro.
          Os dados exibidos pela Plataforma dependem das informações cadastradas pelo próprio
          usuário ou disponibilizadas através de integrações autorizadas.
        </p>
        <p>
          <strong>O ControlEase não é uma instituição financeira, banco, corretora, consultoria
          de investimentos ou serviço de contabilidade.</strong> Informações, projeções, alertas,
          classificações e respostas geradas pela Plataforma possuem caráter informativo e não
          substituem orientação profissional.
        </p>

        <h2>5. Assistente virtual e inteligência artificial</h2>
        <p>
          Algumas funcionalidades podem utilizar inteligência artificial para interpretar
          mensagens, organizar informações, responder perguntas ou auxiliar na utilização da
          Plataforma.
        </p>
        <p>
          Respostas automatizadas podem conter imprecisões. O usuário deve revisar informações
          relevantes antes de tomar decisões financeiras, contratuais, fiscais ou de investimento.
        </p>

        <h2>6. WhatsApp e serviços de terceiros</h2>
        <p>
          O ControlEase pode utilizar serviços de terceiros, incluindo a
          <strong>Meta Platforms, Inc. / WhatsApp Business Platform</strong>, provedores de
          inteligência artificial, infraestrutura em nuvem e serviços de pagamento.
        </p>
        <p>
          O uso dessas integrações também poderá estar sujeito aos termos, políticas e regras
          dos respectivos fornecedores.
        </p>

        <h2>7. Assinaturas, planos e pagamentos</h2>
        <p>
          Algumas funcionalidades do ControlEase podem exigir assinatura ou pagamento.
          Quando aplicável, preço, periodicidade, benefícios do plano e demais condições serão
          apresentados antes da contratação.
        </p>
        <p>
          Os pagamentos podem ser processados por parceiros especializados, como a
          <strong>Stripe</strong>. O ControlEase não armazena números completos de cartão de
          crédito em seus servidores quando o processamento é realizado pelo parceiro.
        </p>

        <h2>8. Uso permitido da Plataforma</h2>
        <p>Ao utilizar o ControlEase, você se compromete a não:</p>
        <ul>
          <li>Utilizar a Plataforma para atividades ilegais, fraudulentas ou abusivas;</li>
          <li>Tentar acessar contas, dados, sistemas ou áreas sem autorização;</li>
          <li>Interferir no funcionamento, segurança ou disponibilidade dos serviços;</li>
          <li>
            Executar ataques, varreduras, automações abusivas ou tentativas de contornar
            mecanismos de segurança;
          </li>
          <li>
            Copiar, modificar, distribuir ou explorar indevidamente partes da Plataforma,
            salvo quando expressamente autorizado;
          </li>
          <li>Utilizar o serviço de forma que viole direitos de terceiros.</li>
        </ul>

        <h2>9. Propriedade intelectual</h2>
        <p>
          A marca ControlEase, identidade visual, interfaces, códigos, textos, elementos gráficos,
          funcionalidades e demais conteúdos próprios da Plataforma são protegidos pela legislação
          aplicável de propriedade intelectual.
        </p>
        <p>
          O uso da Plataforma não transfere ao usuário qualquer direito de propriedade sobre
          esses elementos.
        </p>

        <h2>10. Disponibilidade e alterações do serviço</h2>
        <p>
          Buscamos manter a Plataforma disponível e segura, porém não garantimos funcionamento
          ininterrupto ou livre de falhas. Manutenções, atualizações, indisponibilidades de
          terceiros, eventos de segurança ou circunstâncias técnicas podem afetar temporariamente
          o serviço.
        </p>
        <p>
          Funcionalidades poderão ser adicionadas, alteradas ou descontinuadas quando necessário
          para evolução, segurança ou adequação da Plataforma.
        </p>

        <h2>11. Suspensão e encerramento de conta</h2>
        <p>
          Poderemos restringir, suspender ou encerrar o acesso à Plataforma em situações de
          violação destes Termos, fraude, risco à segurança, determinação legal ou uso que possa
          prejudicar outros usuários ou nossos sistemas.
        </p>
        <p>
          O usuário também poderá solicitar o encerramento da conta e a exclusão de seus dados
          conforme as instruções disponibilizadas na página de
          <a href="/exclusao-de-dados">Exclusão de Dados</a>.
        </p>

        <h2>12. Privacidade e proteção de dados</h2>
        <p>
          O tratamento de dados pessoais realizado pelo ControlEase é descrito em nossa
          <a href="/politica-de-privacidade">Política de Privacidade</a>, que integra estes
          Termos para todos os efeitos aplicáveis.
        </p>

        <h2>13. Limitação de responsabilidade</h2>
        <p>
          Dentro dos limites permitidos pela legislação, o ControlEase não será responsável por
          prejuízos decorrentes de informações incorretas fornecidas pelo usuário, decisões tomadas
          exclusivamente com base em conteúdo automatizado, falhas de serviços de terceiros ou
          uso da Plataforma em desacordo com estes Termos.
        </p>
        <p>
          Nada nestes Termos exclui direitos ou responsabilidades que não possam ser afastados
          pela legislação brasileira.
        </p>

        <h2>14. Alterações destes Termos</h2>
        <p>
          Estes Termos poderão ser atualizados para refletir alterações na Plataforma, em nossas
          práticas ou na legislação. A versão vigente e sua data de atualização serão mantidas
          nesta página.
        </p>

        <h2>15. Legislação aplicável e contato</h2>
        <p>
          Estes Termos são regidos pela legislação da República Federativa do Brasil, respeitados
          os direitos assegurados pela legislação de proteção ao consumidor e demais normas
          aplicáveis.
        </p>
        <p>
          Em caso de dúvidas relacionadas a estes Termos ou ao ControlEase, entre em contato pelo
          e-mail:
          <a href="mailto:controleasebr@gmail.com">controleasebr@gmail.com</a>.
        </p>
      </article>

      <footer class="privacy-footer">
        <div>
          <strong>ControlEase</strong>
          <span>Controle financeiro de forma simples, clara e segura.</span>
        </div>
        <a href="/">Voltar para a página inicial</a>
      </footer>
    </main>
  </div>
</template>

<script setup>
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.privacy-page {
  --primary: #6c63ff;
  --primary-strong: #5548f6;
  --primary-soft: rgba(108, 99, 255, 0.11);
  --accent: #21d4a7;
  --ink: #131522;
  --muted: #6f7281;
  --line: #ececf4;
  --surface: rgba(255, 255, 255, 0.92);

  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: 24px 20px 48px;
  background:
    radial-gradient(circle at 8% -10%, rgba(108, 99, 255, 0.15), transparent 34%),
    radial-gradient(circle at 95% 10%, rgba(33, 212, 167, 0.12), transparent 28%),
    linear-gradient(180deg, #f8f9ff 0%, #f6f8fb 45%, #f9fafc 100%);
  color: var(--ink);
}

.background-glow {
  position: absolute;
  z-index: 0;
  width: 340px;
  height: 340px;
  border-radius: 999px;
  filter: blur(90px);
  pointer-events: none;
  opacity: 0.34;
}

.background-glow--one {
  top: -130px;
  left: -130px;
  background: rgba(108, 99, 255, 0.48);
}

.background-glow--two {
  top: 180px;
  right: -160px;
  background: rgba(33, 212, 167, 0.32);
}

.topbar,
.privacy-shell {
  position: relative;
  z-index: 1;
}

.topbar {
  width: min(1080px, 100%);
  margin: 0 auto 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  color: var(--ink);
  text-decoration: none;
}

.brand-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 3px;
  padding: 10px 9px;
  border-radius: 13px;
  background: linear-gradient(145deg, var(--primary) 0%, var(--primary-strong) 100%);
  box-shadow: 0 10px 28px rgba(85, 72, 246, 0.24);
  transform: rotate(-1deg);
}

.brand-icon span {
  display: block;
  width: 5px;
  border-radius: 999px;
  background: #fff;
  transform: skewX(-13deg);
}

.brand-icon span:nth-child(1) { height: 13px; opacity: 0.82; }
.brand-icon span:nth-child(2) { height: 20px; }
.brand-icon span:nth-child(3) { height: 16px; opacity: 0.92; }

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-text strong {
  font-size: 1rem;
  letter-spacing: -0.02em;
}

.brand-text small {
  margin-top: 4px;
  color: var(--muted);
  font-size: 0.72rem;
}

.home-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid rgba(108, 99, 255, 0.18);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 8px 28px rgba(20, 22, 35, 0.06);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  color: #4f46df;
  font-size: 0.9rem;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.home-button svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.home-button:hover {
  transform: translateY(-2px);
  border-color: rgba(108, 99, 255, 0.34);
  box-shadow: 0 13px 34px rgba(20, 22, 35, 0.09);
}

.privacy-shell {
  width: min(920px, 100%);
  margin: 0 auto;
}

.privacy-hero {
  position: relative;
  overflow: hidden;
  padding: 52px 56px 46px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 26px 26px 0 0;
  background:
    linear-gradient(135deg, rgba(84, 72, 246, 0.98) 0%, rgba(108, 99, 255, 0.96) 54%, rgba(47, 205, 170, 0.92) 150%);
  box-shadow: 0 22px 60px rgba(70, 66, 173, 0.16);
  color: #fff;
}

.privacy-hero::before,
.privacy-hero::after {
  content: '';
  position: absolute;
  border-radius: 999px;
  pointer-events: none;
}

.privacy-hero::before {
  width: 280px;
  height: 280px;
  top: -150px;
  right: -40px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.privacy-hero::after {
  width: 170px;
  height: 170px;
  right: 50px;
  bottom: -115px;
  background: rgba(255, 255, 255, 0.07);
}

.eyebrow {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  padding: 7px 11px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h1 {
  position: relative;
  z-index: 1;
  max-width: 650px;
  margin: 18px 0 10px;
  font-size: clamp(2.05rem, 5vw, 3.45rem);
  line-height: 1.04;
  letter-spacing: -0.05em;
}

.hero-description {
  position: relative;
  z-index: 1;
  max-width: 610px;
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 1rem;
  line-height: 1.65;
}

.updated {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 0.82rem;
  font-weight: 600;
}

.updated-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #8ef5d9;
  box-shadow: 0 0 0 5px rgba(142, 245, 217, 0.12);
}

.privacy-container {
  position: relative;
  padding: 52px 56px 58px;
  border: 1px solid rgba(233, 233, 243, 0.92);
  border-top: 0;
  border-radius: 0 0 26px 26px;
  background: var(--surface);
  box-shadow: 0 22px 60px rgba(23, 25, 42, 0.07);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  line-height: 1.78;
  color: #3d4050;
}

.privacy-container > p:first-child {
  margin-top: 0;
  padding: 18px 20px;
  border: 1px solid rgba(108, 99, 255, 0.12);
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(108, 99, 255, 0.07), rgba(33, 212, 167, 0.05));
  color: #353849;
}

h2 {
  position: relative;
  margin: 38px 0 13px;
  padding-left: 17px;
  color: #171928;
  font-size: 1.12rem;
  line-height: 1.35;
  letter-spacing: -0.02em;
}

h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.19em;
  width: 4px;
  height: 1.15em;
  border-radius: 999px;
  background: linear-gradient(180deg, var(--primary), var(--accent));
}

p,
li {
  font-size: 0.96rem;
}

p {
  margin: 0 0 16px;
}

strong {
  color: #222535;
}

ul {
  margin: 8px 0 18px;
  padding-left: 0;
  list-style: none;
}

li {
  position: relative;
  margin-bottom: 10px;
  padding-left: 25px;
}

li::before {
  content: '';
  position: absolute;
  top: 0.66em;
  left: 3px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--primary);
  box-shadow: 0 0 0 4px var(--primary-soft);
}

a {
  color: var(--primary-strong);
}

.privacy-container a {
  font-weight: 700;
  text-decoration: none;
  border-bottom: 1px solid rgba(85, 72, 246, 0.24);
}

.privacy-container a:hover {
  border-bottom-color: currentColor;
}

.privacy-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 8px 0;
  color: var(--muted);
}

.privacy-footer div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.privacy-footer strong {
  font-size: 0.9rem;
}

.privacy-footer span,
.privacy-footer a {
  font-size: 0.8rem;
}

.privacy-footer a {
  color: var(--primary-strong);
  font-weight: 700;
  text-decoration: none;
}

@media (max-width: 720px) {
  .privacy-page {
    padding: 16px 12px 32px;
  }

  .topbar {
    margin-bottom: 18px;
  }

  .brand-text small {
    display: none;
  }

  .home-button {
    min-height: 42px;
    padding: 0 13px;
    font-size: 0.82rem;
  }

  .privacy-hero {
    padding: 38px 26px 34px;
    border-radius: 22px 22px 0 0;
  }

  .privacy-container {
    padding: 36px 24px 42px;
    border-radius: 0 0 22px 22px;
  }

  .privacy-container > p:first-child {
    padding: 15px 16px;
  }

  h2 {
    margin-top: 34px;
  }

  .privacy-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    padding-inline: 4px;
  }
}

@media (max-width: 460px) {
  .brand-icon {
    width: 38px;
    height: 38px;
    border-radius: 11px;
  }

  .brand-text strong {
    font-size: 0.92rem;
  }

  .home-button span {
    font-size: 0;
  }

  .home-button span::after {
    content: 'Home';
    font-size: 0.82rem;
  }

  .privacy-hero {
    padding-inline: 21px;
  }

  .privacy-container {
    padding-inline: 20px;
  }
}
</style>
